import {
	get,
	clone,
} from "lodash";

// WSNotificationTypeCategoryInfo represents the first level of notification type category used to group notification types.
export default class WSNotificationTypeCategoryInfo {
	constructor(obj = {}) {
		this.name = get(obj, "name", null);
		this.description = get(obj, "description", null);
	}

	static fromBackoffice(data) {
		const result = new WSNotificationTypeCategoryInfo(data);
		return result;
	}

	toBackoffice() {
		const result = clone(this);
		return result;
	}

	toResolver() {
		const forGraphql = clone(this);
		return forGraphql;
	}
}

export const WSNotificationTypeCategoryInfoType = [ `
	type WSNotificationTypeCategoryInfo {
		name: String
		description: String
	}
` ];
